module.exports={
	"Form": "LineItemCreateManifest",
	"Scope": "LineItem-Create",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-Create-Identity",
				"Group": "LineItem-Create-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-Create-Identity",
				"Group": "LineItem-Create-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-Create-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-Create-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-Create-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-Create-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-Create-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-Create-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-Create-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-Create-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-Create-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-Create-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-Create-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Create-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Create-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-Create-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-Create-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-Create-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-Create-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-Create-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-Create-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-Create-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-Create-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-Create-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-Create-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
